import React, { useEffect } from "react";
import KickImage from 'Reuseables/KickImage';
import Slider from "react-slick";
import { connect } from "react-redux";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { editorsChoicePage } from "../../../actions/productAction";

import { CarouselProduct } from "../Luxury";

const LuxuryHotProducts = ({
  dataProducts,
  isFetching,
  getProducts,
  history
}) => {
  useEffect(() => {
    getProducts("editors-choices", {
      params: {
        page: 1,
        availables: true,
        category: "handbags",
      },
    });
  }, []);

  if (dataProducts.length === 0) return null;

  return (
    <div style={{ boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)", padding: "20px 50px 0px 50px", borderRadius: "10px", width: "90vw", margin: "0 auto 0 auto" }} className="hot-products-section">
      <h6>Hot Products</h6>
      <p className="view-all">
        <Link to={"/luxury/hot-products"} target="_blank">
          View All
        </Link>
      </p>
      <CarouselProduct dataProducts={dataProducts} history={history} isHotProducts isLuxuryHotProducts />
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataProducts: state.dataProduct.searchResult,
  isFetching: state.dataProduct.stillPending
})

const mapDispatchToProps = {
  getProducts: editorsChoicePage
}

export default connect(mapStateToProps, mapDispatchToProps)(LuxuryHotProducts);
